import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class NewSaleReportRepository extends Base2Repository {
  getEntityIdentifier() {
    return "low-stock-report";
  }

  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({
      fetch: "v1/reports/find_sales_totals"
    });
  }

  getUrlSaleReport() {
    return "v1/reports/find_sales_totals";
  }

  //All Sales Report

  async getReportTotalSalesTable(filters) {
    const result = await this.get("/v1/sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      document_number: filters.document_number,
      document_serie: filters.document_serie,
      status: filters.status === "all" ? null : filters.status,
      sellable_uuid: filters.sellable_uuid,
      salesman_uuid: filters.salesman_uuid,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page,
      document_type: filters.type === "all" ? null : filters.type,
      order_origin: filters.order_origin === "all" ? null : filters.order_origin
    });
    return result;
  }

  async getTotalSalesSummary(filters) {
    const result = await this.get("/v1/reports/find_sales_totals", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      salesman_uuid: filters.salesman_uuid,
      to: filters.to,
      status: filters.status === "all" ? null : filters.status
    });
    return result;
  }

  //Customer Report

  async getReportCustomerResults(filters) {
    const result = await this.get("/v1/customers_sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      customer_uuid: filters.customer,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page
    });
    return result;
  }

  async getReportCustomerSalesResults(filters) {
    const result = await this.get("/v1/sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      customer_uuid: filters.customer,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page
    });
    return result;
  }

  async getReportCustomerSummary(filters) {
    const result = await this.get("/v1/reports/find_sales_totals", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      customer_uuid: filters.customer
    });
    return result;
  }

  //Salesman Report

  async getReportSalesmanResults(filters) {
    const result = await this.get("/v1/salesmans_sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page
    });
    return result;
  }

  async getReportSalesmanSalesResults(filters) {
    const result = await this.get("/v1/sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page
    });

    return result;
  }

  async getReportSalesmanSummary(filters) {
    const result = await this.get("/v1/reports/find_sales_totals", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user
    });
    return result;
  }

  // Sellables Report

  async getReportSellablesResults(filters) {
    const result = await this.get("/v1/sellables_sales_reports", {
      company_uuid: filters.company_uuid,
      from: filters.from,
      to: filters.to,
      sellable_uuid: filters.sellable_uuid,
      salesman_uuid: filters.salesman_uuid,
      order: filters.order,
      count: filters.count || 25,
      page: filters.page
    });
    return result;
  }

  // Multilocality Report

  async getMultilocalityReport(filters) {
    const result = await this.get("/v1/multilocality_sales_reports", {
      from: filters.from,
      to: filters.to,
      company_uuid: filters.company_uuid,
      order: filters.order,
      page: filters.page
    });
    return result;
  }

  // Results Pane
  async getDashBoardReports(filters) {
    const result = await this.get("/v1/results_reports", {
      from: filters.from,
      to: filters.to,
      company_uuid: filters.company_uuid
    });
    return result;
  }

  // Hours Report
  async getSaleHourReport(from, to) {
    const result = await this.get("/v1/sales_reports_by_hour", {
      from: from,
      to: to
    });
    return result;
  }
}

export default new NewSaleReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/new-sale-report.repository.js